import { Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Subscription } from 'rxjs'

import { TranslateService } from '@ngx-translate/core'
import { SiteService } from '../../../services/site.service'
import { MessageService } from '../../../services/message.service'
import { CustomerChangeRequestTypes } from '../../../enumeration'

interface ModalData {
	customerChangeRequestTypeId: string
  }

@Component({
    selector: 'app-request-proceed-modal',
    templateUrl: './request-proceed-modal.component.html',
    styleUrls: ['./request-proceed-modal.component.scss'],
    standalone: false
})
export class RequestProceedModalComponent implements OnInit 
{
	loginSessionExpiredSubscription: Subscription

	customerQuestion: string = ''

	constructor(
		public dialogRef: MatDialogRef<RequestProceedModalComponent>, @Inject(MAT_DIALOG_DATA) public data: ModalData,
		private siteService: SiteService,
		private translateService: TranslateService,
		private messageService: MessageService
	) 
	{
		this.loginSessionExpiredSubscription = this.messageService.loginSessionExpired$.subscribe(() =>
		{
			this.closeModal()
		})
	}

	ngOnInit() 
	{
		if (this.data.customerChangeRequestTypeId)
		{
			switch (this.siteService.customerRequestType)
			{
				case CustomerChangeRequestTypes.AddressChange:
					this.customerQuestion = this.translateService.instant('REQUEST_PROCEED_ADDRESS_CHANGE')
					break
				case CustomerChangeRequestTypes.BankAccountChange:
					this.customerQuestion = this.translateService.instant('REQUEST_PROCEED_BANK_ACCOUNT_CHANGE')
					break
				case CustomerChangeRequestTypes.EmailChange:
					this.customerQuestion = this.translateService.instant('REQUEST_PROCEED_EMAIL_CHANGE')
					break
				case CustomerChangeRequestTypes.LeaseTransfer:
					this.customerQuestion = this.translateService.instant('REQUEST_PROCEED_LEASE_TRANSFER')
					break
				case CustomerChangeRequestTypes.NameChange:       
					this.customerQuestion = this.translateService.instant('REQUEST_PROCEED_NAME_CHANGE')
					break
				case CustomerChangeRequestTypes.OtherRequest:       
					this.customerQuestion = this.translateService.instant('REQUEST_PROCEED_OTHER_CHANGE')
					break
				case CustomerChangeRequestTypes.PaymentDateChange:       
					this.customerQuestion = this.translateService.instant('REQUEST_PROCEED_PAYMENT_DUE_DATE_CHANGE')
					break
				case CustomerChangeRequestTypes.PhoneChange:       
					this.customerQuestion = this.translateService.instant('REQUEST_PROCEED_PHONE_CHANGE')
					break
				default:
					this.customerQuestion = this.translateService.instant('REQUEST_PROCEED_OTHER_CHANGE')      
			}
		}
	}

	closeModal()
	{
		this.dialogRef.close(false)
	}

	proceed()
	{
		this.dialogRef.close(true)
	}

	notProceed()
	{
		this.dialogRef.close(false)
	}
}
